import types from '../constants/VoteActionTypes';
import {
  createItemFail,
  createItemSuccess,
  fetchItemFail,
  fetchItemsFail,
  fetchItemsSuccess,
  fetchItemSuccess,
  removeItemFail,
  removeItemSuccess,
  updateItemFail,
  updateItemSuccess,
} from './utils';

const initialState = {
  status: { fetch: {} },
  items: {},
};

export default function votes(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_VOTE_SUCCESS:
      return fetchItemSuccess(state, action);
    case types.FETCH_VOTE_FAIL:
      return fetchItemFail(state, action);

    case types.FETCH_VOTES_SUCCESS:
      return fetchItemsSuccess(state, action);
    case types.FETCH_VOTES_FAIL:
      return fetchItemsFail(state, action);

    case types.CREATE_VOTE_SUCCESS:
      return createItemSuccess(state, action);
    case types.CREATE_VOTE_FAIL:
      return createItemFail(state, action);

    case types.UPDATE_VOTE_SUCCESS:
      return updateItemSuccess(state, action);
    case types.UPDATE_VOTE_FAIL:
      return updateItemFail(state, action);

    case types.DELETE_VOTE_SUCCESS:
      return removeItemSuccess(state, action);
    case types.DELETE_VOTE_FAIL:
      return removeItemFail(state, action);

    default:
      return state;
  }
}
